module.exports = __webpack_public_path__ + "static/media/microsoft_office_excel_logo.df5d0958.png";